import {useState, useEffect} from 'react'

// allows us to keep track of window scroll posiiton
export function useScrollHeight() {
  const [scrollHeight, setScrollHeight] = useState(window.scrollY);
  useEffect(() => {
    const handleScroll = () => setScrollHeight(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  });
  return scrollHeight;
}

// allows us to keep track of window scroll posiiton
export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  return windowWidth;
}